import { render, staticRenderFns } from "./OnvifConfirmationDialog.vue?vue&type=template&id=5e0d545b&scoped=true"
import script from "./OnvifConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./OnvifConfirmationDialog.vue?vue&type=script&lang=js"
import style0 from "./OnvifConfirmationDialog.vue?vue&type=style&index=0&id=5e0d545b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0d545b",
  null
  
)

export default component.exports